import type {
  FolderResponse,
  ViewResponse,
} from "@redotech/effect-api-shared/rpc/view-folder";
import { useLiveQuery } from "@tanstack/react-db";
import { useSupportViewsFoldersCollections } from "../providers/support-views-folders-provider";

export function useSupportV2ViewsAndFolders(): {
  views: ViewResponse[];
  folders: FolderResponse[];
} {
  const collections = useSupportViewsFoldersCollections();

  const viewsResult = useLiveQuery(
    (q) => q.from({ view: collections.views }),
    [],
  );

  const foldersResult = useLiveQuery(
    (q) => q.from({ folder: collections.folders }),
    [],
  );

  return { views: viewsResult.data, folders: foldersResult.data };
}
